/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import SiteAddress from 'components/SiteAddress/SiteAddress';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class SelfAuditMultiSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>
              {`${response && response.length} ${t('actionDrawer:Asset(s) confirmed for audit')}`}
            </h3>
            <p>{t('actionDrawer:The following asset(s) has been successfully set for audit.')}</p>
            <ul>
              <li>
                <b>{t('actionDrawer:Asset(s) to be audited')}:</b>
              </li>
              {response.map((asset, index) => {
                return (
                  <li key={asset.id}>
                    {`${asset.asset_number}, ${asset.manufacturer}, ${asset.model}`}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:Close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
